import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/hyperbet/images/sideNav/sideNavLogo.png';

export default function Index() {
  return <Image src={logo} maxW="180px" position="relative" top="0.5" />;
}
